export const absenceReasons = [
  ['R', 'Repos'], ['M', 'Maladie'], ['CP', 'Congés payés'], ['RTT', 'RTT'],
  ['AJ', 'Absence justifiée'], ['AI', 'Absence injustifiée'], ['AT', 'Accident du travail'], ['AUTRE', 'Autre'],
];
export const hasDayHours = (sheet, day) => (Number(sheet.hours?.[day]) || 0) + (Number(sheet.nightHours?.[day]) || 0) > 0;
export function missingAbsenceDays(sheet, days) {
  return days.filter(day => day.inContract !== false && !hasDayHours(sheet, day.key) && !String(sheet.absences?.[day.key] || '').trim());
}
